import { ActionTree } from "vuex";
import { AxiosResponse } from "axios";
import { IReceptionDay, IComponent } from "@/models";
import { apiClient } from "@/services";
import { IComponentState } from "./state";
import {
    ADD_SEARCH_COMPONENTS,
    ADD_EMPTY_SEARCH_COMPONENTS,
    CLEAN_SEARCH,
} from "./mutations-type";

export const actions: ActionTree<IComponentState, number> = {
    async fetchComponentWithPrefix(context, prefix: string): Promise<AxiosResponse<IComponent[]>> {
        const response = await apiClient.get<IComponent[]>(`/components/${prefix}`);

        context.commit(ADD_SEARCH_COMPONENTS, response.data);

        return response;
    },

    addEmptySearchComponents(context): void {
        context.commit(ADD_EMPTY_SEARCH_COMPONENTS);
    },

    cleanSearch(context): void {
        context.commit(CLEAN_SEARCH);
    },
};
